// Se faire plaisir : acheter du bien-être, avec un plaisir qui s'use s'il est répété dans sa catégorie (sauf pendant
// le job d'été, où rien d'autre ne fait remonter le moral). Les envies achetées sur un coup de tête sont des achats.
import { TREATS, TREAT_DECAY, TREAT_WINDOW_DAYS, type PleasureCategory, type TreatDef } from '../content/treats';
import { round2 } from '../engine/finance';
import { t } from '../engine/i18n';
import type { GameState } from '../engine/state';
import { addJournal, addWellbeing, payFromCash } from './actions';
import { purchasePenalty } from './decouvert';

/** Pendant le job d'été, le temps de jeu ne passe pas, et les plaisirs ne s'usent pas. */
export function inSummer(state: GameState): boolean {
  return state.stage === 'prologue' && state.prologueStep === 'summer';
}

/** Les plaisirs de cette catégorie achetés dans le mois : chacun divise le suivant par deux. */
export function recentTreats(state: GameState, category: PleasureCategory): number {
  if (inSummer(state)) return 0;
  return (state.pleasureDays[category] ?? []).filter((day) => state.day - day < TREAT_WINDOW_DAYS).length;
}

/** Bien-être que rapporterait maintenant un plaisir de cette valeur de base et de cette catégorie. */
export function pleasureBonus(state: GameState, base: number, category: PleasureCategory): number {
  return base * Math.pow(TREAT_DECAY, recentTreats(state, category));
}

export function treatBonus(state: GameState, treat: TreatDef): number {
  return pleasureBonus(state, treat.wellbeing, treat.category);
}

/** Applique le bien-être d'un achat plaisir et le compte pour les suivants de la même catégorie. */
export function enjoyPurchase(state: GameState, base: number, category: PleasureCategory): void {
  addWellbeing(state, pleasureBonus(state, base, category));
  if (inSummer(state)) return;
  const recent = (state.pleasureDays[category] ?? []).filter((day) => state.day - day < TREAT_WINDOW_DAYS);
  state.pleasureDays = { ...state.pleasureDays, [category]: [...recent, state.day] };
}

/** Bien-être de base d'une envie achetée : de +2 pour une petite chose à +6 au plus. */
export function impulseBaseBonus(price: number): number {
  return Math.min(6, 2 + price / 100);
}

/** Le prix d'un petit plaisir suit la hausse des prix ; le plaisir, lui, reste le même. */
export function treatPrice(state: GameState, treat: TreatDef): number {
  return round2(treat.price * state.priceLevel * purchasePenalty(state));
}

export function buyTreat(state: GameState, id: string): void {
  const treat = TREATS.find((item) => item.id === id);
  if (!treat) return;
  const price = treatPrice(state, treat);
  if (state.cash < price) return;
  payFromCash(state, price);
  enjoyPurchase(state, treat.wellbeing, treat.category);
  addJournal(state, 'journal.treat', { title: t(treat.title) });
}
